'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["users"];
import { DropdownUserItem } from "../../primitive-dropdown/dropdown-user-item";
import { GenericDropdown } from "./generic-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
export function UsersDropdown(_ref) {
  var users = _ref.users,
    props = _objectWithoutProperties(_ref, _excluded);
  var options = users.map(function (option) {
    return {
      value: option.value,
      label: option.name,
      element: function element(elementProps) {
        return /*#__PURE__*/_jsx(DropdownUserItem, _objectSpread({
          user: option
        }, elementProps));
      }
    };
  });
  return /*#__PURE__*/_jsx(GenericDropdown, _objectSpread(_objectSpread({}, props), {}, {
    options: options
  }));
}